import { useParams } from "react-router-dom";
import { ChefHat } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { fmtDateTime } from "@/lib/format";
import { MatrixTable, MatrixLegend } from "./AllergenMatrixPage";
import { Loading, ErrorState } from "@/components/common/States";
import axios from "axios";

export default function PublicAllergensPage() {
  const { siteId } = useParams();
  const { data, loading, error, reload } = useFetch(() => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/allergens/${siteId}`).then((r) => r.data), [siteId]);
  return (
    <div className="min-h-screen bg-[#F7F6F2]" data-testid="public-allergens-page">
      <header className="bg-[#1B2826] px-5 py-4 text-white"><div className="mx-auto flex max-w-5xl items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-md bg-[#1F5F57]"><ChefHat className="h-5 w-5" /></span><div><div className="text-lg font-bold leading-tight">{data?.site?.name || "Allergeni"}</div><div className="text-xs text-slate-300">Informazioni sugli allergeni · Reg. UE 1169/2011</div></div></div></header>
      <main className="mx-auto max-w-5xl px-4 py-6">
        {loading ? <Loading /> : error ? <ErrorState message={error} onRetry={reload} /> : (
          <>
            <p className="mb-4 text-sm text-slate-600">Elenco aggiornato il {fmtDateTime(data.updated_at)}. Per qualsiasi dubbio chiedi al personale di sala.</p>
            <div className="card hidden overflow-x-auto md:block"><MatrixTable data={data} /></div>
            <MatrixTable data={data} mobileCards />
            <div className="mt-4 hidden md:block"><MatrixLegend /></div>
          </>
        )}
      </main>
    </div>
  );
}
